<div
  *transloco="let t; read: 'widgets.options'"
  class="xi-modal__container grid-chart-options-dialog__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('chart-options') }}</h2>

  <div class="xi-modal__content">
    <form [formGroup]="formGroup" class="transpose-row">
      <xi-checkbox
        [label]="t('transpose')"
        formControlName="transpose"
        color="CX"
        class="grid-analytic-item-selector-dialog__show"
        [matTooltip]="isComparisonActive ? t('transpose-disabled-comparison') : null"
        matTooltipPosition="above"
      ></xi-checkbox>
      <xi-checkbox
        [label]="t('show-delta-column')"
        formControlName="showDeltaColumn"
        color="CX"
        class="grid-analytic-item-selector-dialog__show"
        [matTooltip]="deltaTooltip"
        matTooltipPosition="above"
      ></xi-checkbox>
    </form>
    <app-numeric-metadata-field-selector
      [rows]="data.payload.numericMetadataFields"
      [hasSettings]="true"
      [canSetColor]="false"
      [canSetDecimals]="true"
      [canModifyField]="false"
      [isReadOnly]="isReadOnly"
      [sentimentScale]="data.sentimentScale"
      (valueChange)="onNumericMetadataFieldsChanged($event)"
      (isValid)="onNumericMetadataFieldsIsValid($event)"
    ></app-numeric-metadata-field-selector>
  </div>

  <div class="xi-modal__actions grid-chart-options-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [disabled]="!isValid"
      [text]="t('apply')"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
